var _defs, _rect, _rect2, _rect3, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "7f93a023a1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 56.25 0 L 318.75 0 L 318.75 375 L 56.25 375 Z M 56.25 0 ",
    clipRule: "nonzero"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "transparent",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "transparent",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "transparent",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7f93a023a1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M 187.5 0 C 115.03125 0 56.25 58.78125 56.25 131.25 C 56.25 229.6875 187.5 375 187.5 375 C 187.5 375 318.75 229.6875 318.75 131.25 C 318.75 58.78125 259.96875 0 187.5 0 Z M 187.5 178.125 C 161.625 178.125 140.625 157.125 140.625 131.25 C 140.625 105.375 161.625 84.375 187.5 84.375 C 213.375 84.375 234.375 105.375 234.375 131.25 C 234.375 157.125 213.375 178.125 187.5 178.125 Z M 187.5 178.125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.fac94e8d.svg";
export { ForwardRef as ReactComponent };